interface MdastNode {
	type: string;
	value?: string;
	children?: MdastNode[];
}

const BR_TAG = /^<br\s*\/?>$/i;

const visit = (node: MdastNode) => {
	if (!node.children) return;
	node.children = node.children.map((child) => {
		if (child.type === 'html' && child.value !== undefined && BR_TAG.test(child.value.trim())) {
			return { type: 'break' };
		}
		visit(child);
		return child;
	});
};

/**
 * react-markdown renders raw HTML as text, so a `<br>` inside a table cell (the
 * only way GFM can hold a line break there) would show literally. Turn bare
 * `<br>` nodes into Markdown line breaks; every other HTML node is left alone.
 */
export const remarkBrTags = () => (tree: MdastNode) => {
	visit(tree);
};
